import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editOrganization } from 'components/settings/actions/organization';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import PrettyNumber from '../PrettyNumber';
const OutboundNumberModal = ({ isShown, number, phoneNumbers, onHide, }) => {
    const { getItems } = phoneNumbers;
    const { meta: { asyncStatus }, organization: { id: orgId, default_outbound_number: outboundNumber }, } = useSelector((state) => state.settings.organization);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const updateOutboundNumber = useCallback(() => {
        if (!number) {
            return;
        }
        const { e164_format: default_outbound_number } = number;
        setIsLoading(true);
        dispatch(editOrganization(orgId, {
            updates: {
                default_outbound_number,
            },
        }, {
            title: 'Success',
            text: `${default_outbound_number} is now the default caller ID for your organization`,
            className: 'success',
            type: 'organizationSaved',
            icon: 'i-done',
            time: 5000,
        }));
    }, [orgId, number, dispatch, setIsLoading]);
    /*
     * Check when in redux state the selected outbound number becomes selected.
     */
    useEffect(() => {
        if (!number) {
            return;
        }
        const { e164_format } = number;
        const isOutboundNumberSelected = outboundNumber === e164_format;
        if (isLoading && isOutboundNumberSelected) {
            setIsLoading(false);
            getItems();
            onHide();
        }
    }, [
        asyncStatus,
        number,
        outboundNumber,
        isLoading,
        setIsLoading,
        getItems,
        onHide,
    ]);
    if (!number) {
        return null;
    }
    return (_jsx(ConfirmModal, Object.assign({ isShown: isShown, headline: "Set as default caller ID", confirmText: "Save", cancelText: "Cancel", confirmVariant: "primary", confirmProps: { isLoading }, confirm: updateOutboundNumber, cancel: onHide }, { children: _jsxs(_Fragment, { children: [_jsxs(Text.Paragraph, Object.assign({ withMarginBottom: true }, { children: ["You\u2019re about to set the following phone number as the default caller ID for your ", _jsx("strong", { children: "entire organization:" })] })), _jsx(Text.Paragraph, Object.assign({ variant: "1", withMarginBottom: true }, { children: _jsx(PrettyNumber, { number: number }) })), _jsx(Text.Paragraph, { children: "This will be the phone number your customers see every time calls are made from your organization." })] }) })));
};
export default OutboundNumberModal;
